var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _rect, _path11, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ProtectiveGear502(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAB400",
    d: "M40,20v-9c0-3.866-3.134-7-7-7h-2c-3.866,0-7,3.134-7,7v9h-4v40h11v-7c0-0.552,0.448-1,1-1h0 c0.552,0,1,0.448,1,1v7h11V20H40z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A5078",
    d: "M32,52c0.552,0,1,0.448,1,1V4h-2v49C31,52.448,31.448,52,32,52z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DC9600",
    d: "M20,20h-0.343c-1.061,0-2.078,0.421-2.828,1.172l-5.657,5.657C10.421,27.579,10,28.596,10,29.657V43 c0,0.552,0.448,1,1,1h6c0.552,0,1-0.448,1-1V32l2-2V20z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A5078",
    d: "M15,52h-4c-0.552,0-1-0.448-1-1v-6c0-0.552,0.448-1,1-1h5v7C16,51.552,15.552,52,15,52z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00325A",
    d: "M17,49L17,49c-0.552,0-1-0.448-1-1v-4h1c0.552,0,1,0.448,1,1v3C18,48.552,17.552,49,17,49z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#DC9600",
    d: "M44,20h0.343c1.061,0,2.078,0.421,2.828,1.172l5.657,5.657c0.75,0.75,1.172,1.768,1.172,2.828V43 c0,0.552-0.448,1-1,1h-6c-0.552,0-1-0.448-1-1V32l-2-2V20z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A5078",
    d: "M49,52h4c0.552,0,1-0.448,1-1v-6c0-0.552-0.448-1-1-1h-5v7C48,51.552,48.448,52,49,52z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00325A",
    d: "M47,49L47,49c0.552,0,1-0.448,1-1v-4h-1c-0.552,0-1,0.448-1,1v3C46,48.552,46.448,49,47,49z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#00A0C8",
    d: "M32,18L32,18c-3.314,0-6-2.686-6-6v-1c0-1.657,1.343-3,3-3h6c1.657,0,3,1.343,3,3v1 C38,15.314,35.314,18,32,18z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0082AA",
    d: "M35,8h-6c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3h6c1.657,0,3,1.343,3,3v-1C38,9.343,36.657,8,35,8z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 16,
    fill: "#C80A50",
    rx: 4.472,
    ry: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 31,
    y: 7,
    fill: "#00325A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A5078",
    d: "M38,22H26c-1.105,0-2-0.895-2-2v0h16v0C40,21.105,39.105,22,38,22z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 2,
    x: 20,
    y: 32,
    fill: "#0A5078"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ProtectiveGear502);
export default __webpack_public_path__ + "static/media/icons8-protective-gear-50-2.7c5dafd8bb937b52d6f5539c2845b552.svg";
export { ForwardRef as ReactComponent };